/**
 * Settings Page
 * User settings and preferences
 */

import { DashboardLayout } from '@/ui/components/layouts/DashboardLayout';
import { Card } from '@/ui/components/ui/card';
import { Settings as SettingsIcon } from 'lucide-react';

export function SettingsPage() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
          <p className="text-gray-600 mt-2">
            Manage your account settings and preferences
          </p>
        </div>

        {/* Placeholder */}
        <Card className="p-12 text-center">
          <div className="flex flex-col items-center gap-4">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
              <SettingsIcon size={32} className="text-gray-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                Settings coming soon
              </h3>
              <p className="text-gray-600 mt-1">
                Account settings and preferences will be available here
              </p>
            </div>
          </div>
        </Card>
      </div>
    </DashboardLayout>
  );
}
